export const firebaseConfig = {
  apiKey: "AIzaSyBGiUsRUfNRfnTz-fEnymyo1MAMRbPnp00",
  authDomain: "landmark-website-dcd61.firebaseapp.com",
  projectId: "landmark-website-dcd61",
  storageBucket: "landmark-website-dcd61.appspot.com",
  messagingSenderId: "504258429945",
  appId: "1:504258429945:web:a51780ddb7c240539e3328"
};
